import {
  Country,
  ProjectSpecification,
  ProjectConstructionType,
  ProjectInvoiceTo,
  Organization,
  Services,
  ServicesLabels,
} from '@consigli/types';
import { formatEnumToReadableText } from '@consigli/utils';
import { useMemo } from 'react';

export const useFormOptions = (organizations: Organization[] = []) => {
  const countryOptions = useMemo(
    () =>
      Object.values(Country).map((country) => ({
        label: country,
        value: country,
      })),
    [],
  );

  const organizationOptions = useMemo(
    () =>
      organizations.map((organization) => ({
        label: organization.name,
        value: organization.id,
      })),
    [organizations],
  );

  const invoiceToOptions = useMemo(
    () =>
      Object.values(ProjectInvoiceTo).map((type) => ({
        label: formatEnumToReadableText(type),
        value: type,
      })),
    [],
  );

  const specificationOptions = useMemo(
    () =>
      Object.values(ProjectSpecification).map((spec) => ({
        label: formatEnumToReadableText(spec),
        value: spec,
      })),
    [],
  );

  const constructionTypeOptions = useMemo(
    () =>
      Object.values(ProjectConstructionType).map((type) => ({
        label: formatEnumToReadableText(type),
        value: type,
      })),
    [],
  );

  const servicesOptions = useMemo(
    () =>
      Object.values(Services).map((service) => ({
        label: ServicesLabels[service],
        value: service,
      })),
    [],
  );

  return {
    countryOptions,
    organizationOptions,
    invoiceToOptions,
    specificationOptions,
    constructionTypeOptions,
    servicesOptions,
  };
};
